import { render, staticRenderFns } from "./SeminarAdd.vue?vue&type=template&id=d9fef0c8&scoped=true&"
import script from "./SeminarAdd.vue?vue&type=script&lang=js&"
export * from "./SeminarAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9fef0c8",
  null
  
)

export default component.exports